/** W10 GOT Result Update pending list (legacy QualityGOT login, manual p254, screenshot 154022). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { GotResultPendingPage } from "@/features/got/components/result-update-pages";

export const Route = createFileRoute("/_app/quality/got/result-update/")({
  beforeLoad: () => {
    if (!useAuth.getState().can("got.result_update"))
      throw redirect({ to: "/" });
  },
  component: GotResultPendingPage,
});
